import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/images/logo.png';
import logomini from '../assets/images/logomini.png';

export default function Navbar() {
  const navigate = useNavigate();
  return (
    <nav className="bg-[#fdf4e4] px-6 py-4 flex items-center justify-between shadow-sm">
      {/* Logo and Title */}
      <div className="flex items-center space-x-3">
      <img src={logomini} className='w-50 h-10' alt="" />
        <img src={logo} alt="Logo" className="w-30 h-10" />
        
      </div>

      {/* Menu Items */}
      <ul className="hidden max-xl:hidden md:flex space-x-20 text-gray-800 font-semibold">

      <li className="hover:text-[#7a5c28] cursor-pointer">
  <a href="/">Home</a>
</li>
<li className="hover:text-[#7a5c28] cursor-pointer">
  <a href="#about">Experience</a>
</li>
<li className="hover:text-[#7a5c28] cursor-pointer">
  <a href="#locations">Tickets</a>
</li>
<li className="hover:text-[#7a5c28] cursor-pointer">
  <a href="#aboutus">About us</a>
</li>
<li className="hover:text-[#7a5c28] cursor-pointer">
  <a href="#footer">Contact</a>
</li>

</ul>


      {/* Book Now Button */}
      <button 
        onClick={() => navigate('/bookings/ekho')}
        className="bg-[#7a5c28] text-white px-4 py-2 rounded-full hover:bg-[#61481e] transition"
      >
        Book Now
      </button>
    </nav>
  );
}
